import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-95b3e3c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "facility" }
const _hoisted_2 = { class: "page-container facility__content" }
const _hoisted_3 = { class: "facility__html" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "facility__timetable-title" }, "Opening times are:", -1))
const _hoisted_6 = { class: "facility__timetable" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_subheader = _resolveComponent("a-subheader")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_async_loader = _resolveComponent("a-async-loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_async_loader, {
      "is-loading": _ctx.isLoading,
      "error-message": _ctx.pageErrorMessage
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_subheader, {
          title: _ctx.title,
          "show-video-btn": _ctx.signLanguage
        }, null, 8, ["title", "show-video-btn"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", { innerHTML: _ctx.html }, null, 8, _hoisted_4)
          ]),
          (_ctx.isTimetableVisible)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_5,
                _createElementVNode("ul", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workingHours, (text) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: text,
                      class: "facility__timetable-item"
                    }, _toDisplayString(text), 1))
                  }), 128))
                ])
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.isButtonVisible)
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 1,
                class: "facility__button",
                onClick: _ctx.navigateToConfirmation
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.buttonText), 1)
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["is-loading", "error-message"])
  ]))
}